import { render, staticRenderFns } from "./indexComponent2.vue?vue&type=template&id=8675326c&scoped=true&"
import script from "./indexComponent2.vue?vue&type=script&lang=js&"
export * from "./indexComponent2.vue?vue&type=script&lang=js&"
import style0 from "./indexComponent2.vue?vue&type=style&index=0&id=8675326c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8675326c",
  null
  
)

export default component.exports